export default __webpack_public_path__ + "static/media/aging.56a03118.jpg";